import { post, get } from '../request'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import ApiResponse from '~/model/response'

export const viewAcademic = (token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('academic-year', token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const previousAcademic = (token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('academic-year/previous', token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const addAcademic = (data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('academic-year/add', token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const getAcademic = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('academic-year/edit/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const editAcademic = (id, data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('academic-year/update/' + id, token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const toggleAcademic = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('academic-year/status/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}
